import React, { useEffect, useState } from "react";
import Dialog from "components/Dialog/Dialog";
import ReactTableSimple from 'components/ReactTable/ReactTableSimple';
import { useDispatch, useSelector } from "react-redux";
import { fetchJobRecurringJob } from "store/modules/jobDetails/actions";
import { actions as JobDetailActions, selectors as JobDetailSelectors } from "store/modules/jobDetails";
import { convertUTCToTimezoneWithOffset, formattedStartEndTimeWithOffset } from "utils/time";
import { Checkbox } from "@mui/material";
import moment from "moment";
import { useTranslation } from "react-i18next";

function JobCancelTable({ jobDetail, cancelJob, isFixedTerm }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const data = useSelector(JobDetailSelectors.getRecurringJobList);
    const [selectedList, setselectedList] = useState([]);
    const [selectedId, setselectedId] = useState({});
    const [allSelectedId, setAllSelectedId] = useState(0);
    const isOpenCancelJobDialog = useSelector(JobDetailSelectors.getCancelJobDialogState);
    const isLoading = useSelector(JobDetailSelectors.getIsDeleteJobLoading);

    useEffect(() => {
        dispatch(fetchJobRecurringJob(jobDetail,isFixedTerm));
    }, []);

    useEffect(() => {
        const keys = Object.keys(selectedId);
        const filteredObj = keys.filter((key) => {
            return selectedId[key];
        });
        const filteredArray = filteredObj.map(str => {
            return Number(str);
        });
        setselectedList(filteredArray);
    }, [selectedId]);

    useEffect(() => {
        if (data.length === selectedList.length) {
            if (selectedList.length === 0) {
                setAllSelectedId(0);
            }
            else {
                setAllSelectedId(1);
            }
        }
        else if (data.length >= selectedList.length) {
            if (selectedList.length === 0) {
                setAllSelectedId(0);
            }
            else {
                setAllSelectedId(2);
            }
        }
        else {
            setAllSelectedId(0);
        }
    }, [selectedList]);

    const onCheckAll = () => {
        let newSelected = {};
        if (allSelectedId === 0) {
            data.forEach(x => {
                newSelected[x.id] = true;
            });
        }
        setselectedId(newSelected);
        setAllSelectedId(allSelectedId === 0 ? 1 : 0);
    }

    const onSelectJob = (id) => {
        const newSelected = Object.assign({}, selectedId);
        newSelected[id] = !selectedId[id];
        setselectedId(newSelected);
    }

    const hideCancelDialog = () => {
        setselectedId({});
        setselectedList([]);
        dispatch(JobDetailActions.setIsCancelJobDialogState(false));
    };

    const cancelRecurringJob = (withFuture) => {
        cancelJob(selectedList, jobDetail.id,withFuture,data);
    };

    const columns = [
        {
            Header: () => {
                return (
                    <span>
                        <Checkbox
                            id="allCheck"
                            checked={allSelectedId === 1}
                            indeterminate={allSelectedId === 2}
                            disabled={Boolean(isLoading)}
                            onChange={() => onCheckAll()}
                        />
                    </span>
                )
            },
            id: "checkbox",
            disableFilters: true,
            disableSortBy: true,
            Cell: ({ row: { original } }) => {
                return (
                    <span>
                        <Checkbox
                            disabled={Boolean(isLoading)}
                            checked={selectedId[original.id] === true}
                            onChange={() => onSelectJob(original.id)}
                        />
                    </span>
                )
            },
            className: "-cursor-pointer",
        },
        {
            Header: t("common_table_column_jobId"),
            id: "id",
            accessor: "id",
            disableFilters: true,
            disableSortBy: true,
            Cell: ({ row: { original } }) => {
                return (
                    <span>
                        {original.id}
                    </span>
                )
            },
            className: "-cursor-pointer",
            styles: {
                textAlign: 'left'
            },
        },
        {
            Header: t("common_table_column_jobDate"),
            id: "startUtc",
            accessor: "startUtc",
            disableFilters: true,
            disableSortBy: true,
            styles: {
                textAlign: 'left'
            },
            Cell: ({ row: { original } }) => {
                return (
                    <div>
                        {convertUTCToTimezoneWithOffset(original.startUtc, original.timezone, "MMM Do, YYYY")}
                    </div>
                );
            },
            className: "-cursor-pointer",
        },
        {
            Header: t("common_table_column_shift"),
            id: "Shift",
            disableFilters: true,
            disableSortBy: true,
            Cell: ({ row: { original } }) => {
                return formattedStartEndTimeWithOffset(original.startUtc, original.endUtc, original.timezone);
            },
            accessor: ({ startUtc, endUtc }) => {
                const startTime = moment(startUtc).format("h:mm a");
                const endTime = moment(endUtc).format("h:mm a");
                return `${startTime} - ${endTime}`;
            },
            className: "-cursor-pointer",
            styles: {
                minWidth: '150px'
            },
        },
    ]

    return (
        <Dialog
            open={isOpenCancelJobDialog}
            title={t("page_job_details_cancel_job_title")}
            onClose={hideCancelDialog}
            onConfirm={() => cancelRecurringJob(false)}
            onCancel={hideCancelDialog} 
            modalType={"scrollable"}
            alertType={isFixedTerm ? "warningWithTwoConfirmButtons" : "warning"}
            icon="remove_circle"
            onSecondConfirm={() => cancelRecurringJob(true)}
            confirmText={isFixedTerm ? t("common_labels_yes_current_job") :t("common_labels_yes")}
            secondConfirmText={t("common_labels_yes_future_job") }
            isSecondLoading={isLoading === "futureLoading"}
            isLoading={isLoading === "currentLoading"}
            disabled={Boolean(isLoading)}

        >
            {!isFixedTerm && data.length > 0 &&
                <ReactTableSimple
                    columns={columns}
                    data={data}
                />
            }
        </Dialog>
    )
}

export default JobCancelTable